import { useState, useEffect, useRef } from 'react';
import Bredcrum from '../../components/bredcrum';
import { Tablescom } from '../../components/tablescomp';
import { manufacturerServices } from '../../services/manufacturerServices';
import { Titlebar, Searchbox, Confirmdelete, Shipmentstatus,Orderstatus } from '../../components/fieldsComp';
import { BrowserRouter, Routes, Route, useNavigate } from "react-router";
import { Dialog } from 'primereact/dialog';
import { TabMenu } from 'primereact/tabmenu';
import { localurl } from '../../constant';
import { Toast } from "primereact/toast";
import { exportToExcel } from '../../helpers/exporttoexcel';
import { shipmentServices } from '../../services/shipmentServices';
import { Timeline } from 'primereact/timeline';

const Shipment = () => {

  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [results, setResults] = useState([]);
  const [userloaded, setUserloaded] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [popvisible, setPopvisible] = useState(false);
  const [deleleteid, setDeleleteid] = useState(false);
  const [viewmanufacturer, setViewmanufacturer] = useState([]);
  const [viewvisible, setViewvisible] = useState(false);
  const toast = useRef(null);
  const [quickFilterText, setQuickFilterText] = useState('');
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10); // 🔄 dynamic page size
  const [viewdata, setViewdata] = useState([]);
  const [statusset, setStatusset] = useState('all');


  const items = [
    {
      label: 'All',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('all'),
      // template: (item) => itemRenderer(item, 0)
    },
    {
      label: 'In Transit',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('in_transit'),
      // template: (item) => itemRenderer(item, 0)
    },
    {
      label: 'Pending',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('pending'),
      //  template: (item) => itemRenderer(item, 1)
    },
    {
      label: 'Delivered',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('delivered'),
      //  template: (item) => itemRenderer(item, 2)
    },
  ];

  function handleStockFilter(status) {
    setStatusset(status);
  }

  useEffect(() => {
    getshipment(1, '25');
  }, [statusset])


  useEffect(() => {
    getshipment(currentPage, pageSize);
  }, [currentPage, pageSize, viewdata]);

  useEffect(() => {
    setColDefs(getColDefs(currentPage, pageSize));
  }, [currentPage, pageSize, viewdata]);

  const handleNext = () => {
    if (currentPage < Math.ceil(totalRows / pageSize)) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const deletefreight = (id) => {
    setPopvisible(true);
    setDeleleteid(id);
  }

  const getColDefs = (currentPage, pageSize) => [
    {
      headerName: "SR NO", width: 100,
      valueGetter: (params) => {
        return ((currentPage - 1) * pageSize) + params.node.rowIndex + 1;
      },
    },
    { headerName: "Freight Name", field: "freight_name",tooltipField:"freight_name"},
    { headerName: "Shipment Date", field: "shipment_date" },
    {
      headerName: "Shipment Reference", field: "shipment_reference",tooltipField:"shipment_reference",
      valueGetter: (params) => params.data.shipment_reference, // enables copy
      enableCellTextSelection: true, getValueForClipboard: (params) => {
        return params.value; // plain text version
      }
    },
    { headerName: "Tracking Number", field: "tracking_number",tooltipField:"tracking_number" },
    {
      headerName: "Tracking Status", field: "status",


      cellRenderer: (params) =>
        (<Shipmentstatus status={params.value} />),

    },


    // {
    //   headerName: "Status",
    //   field: "status",
    //   cellRenderer: (params) =>
    //     params.value === "active" ? "Active" : "Inactive",
    // },
    {
      headerName: "Action",
      cellRenderer: (params) => (
        <>
          <button
            className="btn btn-xs btn-primary"
            onClick={() => editredirect(params.data.id, params.data)}
          >
            <i className="icon icon-note"></i>
          </button>
          &nbsp;
          {/* <button
          className="btn btn-danger btn-xs"
          onClick={() => deletefreight(params.data.id)}
        >
          <i className="icon icon-trash"></i>
        </button> */}
          &nbsp;
          <button
            className="btn btn-success btn-xs"
            onClick={() => viewshipmentdata(params.data)}
          >
            <i className="icon icon-eye"></i>
          </button>
        </>
      ),
    },
  ];

  const [colDefs, setColDefs] = useState(getColDefs(1, 5));

  const editredirect = (id, Data) => {
    navigate(`/editshipment/${id}`, { state: { shipment: Data } });
  }

  const viewshipmentdata = (Data) => {
    setViewdata(Data);
    setViewvisible(true);
  }

  const getshipment = (page, pageSize) => {
    setUserloaded(true);
    shipmentServices.getshipment(page, pageSize, { type: statusset }).then((response) => {
      if (response.status == 200) {
        setResults(response.data.data);
        setTotalRows(response.data.total);
        setCurrentPage(response.data.current_page);
        setUserloaded(false);
      } else {
        setResults([]);
        setUserloaded(false);
      }
    }).catch((error) => {
      setResults([]);
      setUserloaded(false);
    });
  }

  const addproductnavigate = () => {
    // navigate.  
    navigate('/addmanufacturer');
  }

  const deletefreightdata = () => {
    if (deleleteid) {
      manufacturerServices.deletefreight(deleleteid).then((response) => {
        if (response.status == 200) {
          setPopvisible(false);
          setDeleleteid(false);
          toast.current.show({ severity: 'success', summary: 'Sale', detail: 'Manufacturer deleted successfully' });
          getshipment(currentPage, pageSize);
        }
      }).catch((error) => {

      });
    }

  }

  const onPaginationChanged = (params) => {
    const gridApi = params.api;
    const newPage = gridApi.paginationGetCurrentPage() + 1;
    if (newPage !== currentPage) {
      setCurrentPage(newPage);
    }
  };

  const handlePageSizeChange = (e) => {
    const newSize = parseInt(e.target.value);
    setPageSize(newSize);
    setCurrentPage(1);           // reset to page 1
    getshipment(1, newSize);       // reload with new size
  };

  const canceldiag = () => {
    setPopvisible(false);
  }

  const handleExport = () => {
    exportToExcel({ data: results, filename: 'shipment' });
  }

  const events = ['2020', '2021', '2022', '2023'];

  return (
    <>
      <Toast ref={toast} />
      {/* <Bredcrum title={'Shipments'} divider={false} /> */}
      <Confirmdelete popvisible={popvisible} deletefun={deletefreightdata} cancel={canceldiag} title="Freight" />


      <Dialog
        header="Shipment Data View"
        visible={viewvisible}
        style={{ width: '60vw' }}
        onHide={() => setViewvisible(false)}
        // footer={footerContent}
        modal
        className="p-fluid"
      >
        <div className="card-body">
          <div className="container mt-4">
            <div className="row" >
              <div class="row mb-3">
                <div class="col-md-6">
                  <label for="freight_provider_id" class="form-label">Freight Provider  </label>
                  <input type="text" value={viewdata.freight_name} readOnly class="form-control"
                    id="shipment_reference" name="shipment_reference" placeholder="Enter shipment reference" />
                </div>
                <div class="col-md-6">
                  <label for="shipment_reference" class="form-label">Shipment Reference </label>
                  <input type="text" value={viewdata.shipment_reference} readOnly class="form-control"
                    id="shipment_reference" name="shipment_reference" placeholder="Enter shipment reference" />
                </div>

              </div>

              <div class="row mb-3">
                <div class="col-md-6">
                  <label for="origin" class="form-label">Origin</label>
                  <input type="text" class="form-control"
                    id="origin" name="origin" readOnly placeholder="Enter Origin" value={viewdata.origin} />
                </div>

                <div class="col-md-6">
                  <label for="destination" class="form-label">Destination</label>
                  <input type="text" class="form-control"
                    id="destination" name="destination" placeholder="Enter Destination" value={viewdata.destination} readOnly />
                </div>

              </div>

              <div class="row mb-3">
                <div class="col-md-6">
                  <label for="freight_cost" class="form-label">Freight Cost</label>
                  <input type="number" placeholder="Enter Freight Cost" class="form-control" id="freight_cost"
                    name="freight_cost" value={viewdata.freight_cost} readOnly />
                </div>
                <div class="col-md-6">
                  <label for="tracking_number" class="form-label">Tracking Number</label>
                  <input type="number" placeholder="Enter Tracking Number" class="form-control" id="tracking_number"
                    name="tracking_number" readOnly value={viewdata.tracking_number} />
                </div>

              </div>

              <div class="row mb-3">
                <div class="col-md-6">
                  <label for="shipment_date" class="form-label">Shipment Date</label>
                  <input type="datetime-local" placeholder="Enter Freight Cost" class="form-control" id="shipment_date"
                    name="shipment_date" readOnly value={viewdata.shipment_date} />
                </div>
                <div class="col-md-6">
                  <label for="status" class="form-label">Status</label>
                  <select disabled class="form-select" id="status" name="status" value={viewdata.status} >
                    <option value="">Select Type</option>
                    <option value="pending">Pending</option>
                    <option value="in_transit">IN Transit</option>
                    <option value="delivered">Delivered</option>
                    <option value="delayed">Delayed</option>
                    <option value="cancelled">Cancelled</option>
                  </select>
                </div>
              </div>

            </div>

          </div>
        </div>
      </Dialog>

      <Dialog visible={visible} position='top' modal style={{ width: '50rem' }} onHide={() => { if (!visible) return; setVisible(false); }}>
        <div className="container py-5">
          <div className="card shadow-lg rounded-4 p-4">
            <h2 className="mb-4 text-center text-primary">Excel Multiple Data Upload</h2>

            <div className="text-center mb-4">
              <a
                href={localurl + "/templates/component.xlsx"}
                download
                className="btn btn-outline-primary rounded-pill px-4"
                target="_blank"
                rel="noopener noreferrer"
              >
                Download Excel Template
              </a>
            </div>
            <div id="status" className="status mt-4 text-center text-success fw-medium"></div>
          </div>
        </div>

      </Dialog>

      <div class="row">
        <div className='col-md-12 mb-2 mt-2'>
          <div className='flex-box justify-content-end flex-align-item-center'>
            {/* <div className=''>
                         <button className='btn btn-primary rounded-pill custom-btn-color custom-btn-br-color ps-5 pe-5' onClick={() => navigate('/addshipment')}>Add Shipment</button> 
                         &nbsp;
                         &nbsp;
                         &nbsp; 
                  </div> */}
            {/* <div><Titlebar text={'Shipments'} /></div> */}
            <Searchbox
              value={quickFilterText}
              onChange={(e) => setQuickFilterText(e.target.value)}
            />
          </div>
        </div>



        <div className="col-md-12 mt-3">
          <div className='row'>
            <div className='col-md-9'>
              <TabMenu model={items} activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} />
            </div>

            <div className='col-md-3'>
              <div>
                <button class="export-btn form-control w-50 pull-right" onClick={() => handleExport()}>
                  <i className='fa fa-file-excel'></i> &nbsp;Export to Excel</button>
              </div>
            </div>
          </div>
          <div className='card'>
            <div className='card-body card-body-style'>
              {/* <Timeline value={events} layout="horizontal" align="top" content={(item) => item} /> */}
              <Tablescom rowdata={results} coldefs={colDefs} isloaded={userloaded}
                quickFilterText={quickFilterText} paginationPageSize={pageSize} onPaginationChanged={onPaginationChanged}
                totalRows={totalRows} currentPage={currentPage} pageSize={pageSize} handleNext={handleNext}
                handlePrevious={handlePrevious}
                handlePageSizeChange={handlePageSizeChange} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Shipment;